import React, { useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'app/BargainWidget/Bargains/WidgetV1/icons/Icons';
import { useBargainHistory } from 'app/BargainWidget/hooks/useBargainHistory';
import { convertToTitleCase, darkenHexColor, formatDate } from 'app/BargainWidget/Bargains/utils/common-utils';
import { getCurrencySymbol } from 'app/BargainWidget/Bargains/utils/currency-utils';
import Badge from 'app/BargainWidget/Bargains/Components/Badge';
import { useBargain } from 'app/BargainWidget/context/BargainContext';

// const data = [
//   {
//     id: "1",
//     productTitle: "Wireless Headphones",
//     createdAt: "2024-02-15T10:30:00Z",
//     offerPrice: 59.99,
//     status: "accepted",
//     quantity: 2,
//     invoiceUrl: "https://example.com/invoice/1"
//   },
//   {
//     id: "2",
//     productTitle: "Smartphone Case",
//     createdAt: "2024-02-14T14:00:00Z",
//     offerPrice: 12.99,
//     status: "pending",
//     quantity: 1,
//     invoiceUrl: ""
//   },
//   {
//     id: "3",
//     productTitle: "Bluetooth Speaker",
//     createdAt: "2024-02-13T09:15:00Z",
//     offerPrice: 29.99,
//     status: "rejected",
//     quantity: 1,
//     invoiceUrl: ""
//   },
//   {
//     id: "4",
//     productTitle: "Laptop Stand",
//     createdAt: "2024-02-12T18:45:00Z",
//     offerPrice: 35.5,
//     status: "accepted",
//     quantity: 1,
//     invoiceUrl: "https://example.com/invoice/4"
//   },
//   {
//     id: "5",
//     productTitle: "Gaming Mouse",
//     createdAt: "2024-02-11T11:20:00Z",
//     offerPrice: 49.99,
//     status: "pending",
//     quantity: 1,
//     invoiceUrl: ""
//   }
// ]


export function BargainHistoryV1() {
  const {translation, widgetSettings} = useBargain();
  const { bargainHistory, totalPages, currentPage, setCurrentPage, loading: historyLoading, fetchBargainHistory } = useBargainHistory();

  useEffect(() => {
    fetchBargainHistory().then(() => {});
  }, [currentPage]);

  const QuantityLabel = ({label, quantity}) => label?.replace("{{quantity}}",quantity) || `x${quantity}`;

  return (
    <div className="se-w-full bargain-widget-v1-history">
      <div className="se-mb-4 bargain-widget-v1-history-title-section">
        <h3 className="se-text-lg se-font-semibold se-text-gray-900 bargain-widget-v1-history-label">{translation?.historyTitle || "Offer History"}</h3>
        <p className="se-text-sm se-text-gray-500 bargain-widget-v1-history-description">{translation?.historyDescription || "View your previous offers and their status"}</p>
      </div>

      <div className="se-min-h-[220px] se-mb-6 bargain-widget-v1-history-content">
        <div className="se-space-y-3 bargain-widget-v1-history-content-spacing">
          {historyLoading
            ? Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="se-h-[52px] se-bg-white se-rounded-xl se-border se-border-gray-200 se-p-3 se-animate-pulse bargain-widget-v1-history-list-skeleton">
                <div className="se-flex se-justify-between se-items-center se-h-full bargain-widget-v1-history-list-skeleton-container">
                  <div className="se-space-y-2 se-flex-1">
                    <div className="se-h-4 se-w-24 se-bg-gray-200 se-rounded" />
                    <div className="se-h-3 se-w-16 se-bg-gray-200 se-rounded" />
                  </div>
                  <div className="se-h-5 se-w-16 se-bg-gray-200 se-rounded" />
                </div>
              </div>
              ))
            : Array.isArray(bargainHistory) &&
              bargainHistory?.map(item => (
                <div
                  key={item.id}
                  className="se-bg-white se-rounded-xl se-border se-border-gray-200 se-p-3 hover:se-border-gray-300 se-transition-colors bargain-widget-v1-history-list-item"
                >
                  <div className="se-flex se-justify-between se-items-center bargain-widget-v1-history-list-item-info-container">
                    <div className="se-space-y-0.5 se-flex-1 se-min-w-0 bargain-widget-v1-history-list-item-info">
                      <div className="se-text-sm se-font-medium se-text-gray-800 se-truncate bargain-widget-v1-history-list-item-product-title">{item?.productTitle}</div>
                      <div className="se-text-xs se-text-gray-500  bargain-widget-v1-history-list-item-date">{formatDate(item?.createdAt)}</div>
                    </div>
                    <div className="se-flex se-items-center se-gap-3 se-shrink-0">
                      <span className="se-text-base se-font-semibold se-text-gray-800 se-w-[60px] se-text-right bargain-widget-v1-history-list-item-price">
                        {getCurrencySymbol()}
                        {item?.offerPrice}
                      </span>
                      <span className="bargain-widget-v1-history-list-item-status"><Badge status={item?.status}>{convertToTitleCase(item?.status)}</Badge></span>
                    </div>
                  </div>
                  <div className="se-flex se-justify-between se-items-center se-mt-2 bargain-widget-v1-history-list-item-actions">
                    <div className="se-text-xs se-font-medium bargain-widget-v1-history-list-item-quantity"><QuantityLabel label={translation?.historyQuantityLabel} quantity={item?.quantity}/></div>
                    {
                      item?.invoiceUrl && (
                        <button
                          style={
                            {
                              '--offer-button-background-color': widgetSettings?.offerButtonBackgroundColor || '#000000',
                              '--offer-button-hover-background-color': darkenHexColor(widgetSettings?.offerButtonBackgroundColor || '#000000', 3),
                              '--offer-button-text-color': widgetSettings?.offerButtonTextColor || '#ffffff',
                            } as any
                          }
                          className="se-px-3 se-py-1 se-text-sm se-font-medium se-rounded-md se-bg-[var(--offer-button-background-color)] hover:se-bg-[var(--offer-button-hover-background-color)] se-text-[var(--offer-button-text-color)] se-transition-colors bargain-widget-v1-history-list-item-checkout-button"
                          onClick={() => window.open(item?.invoiceUrl, "_blank", "noopener noreferrer")}
                        >
                          {translation?.historyCheckout || "Checkout"}
                        </button>
                      )
                    }
                  </div>
                </div>
              ))}
        </div>
      </div>

      <div className="se-flex se-items-center se-justify-end se-border-t se-pt-4 bargain-widget-v1-history-divider">
        <div className="se-flex se-gap-1 bargain-widget-v1-history-pagination-actions">
          <button
            onClick={() => setCurrentPage(p => Math.max(0, p - 1))}
            disabled={currentPage === 0 || historyLoading}
            className="se-p-2 se-rounded-lg hover:se-bg-gray-100 disabled:se-opacity-50 disabled:se-cursor-not-allowed bargain-widget-v1-history-pagination-previous-button"
          >
            <ChevronLeft className="se-w-4 se-h-4" />
          </button>
          <button
            onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))}
            disabled={currentPage === totalPages - 1 || historyLoading}
            className="se-p-2 se-rounded-lg hover:se-bg-gray-100 disabled:se-opacity-50 disabled:se-cursor-not-allowed bargain-widget-v1-history-pagination-next-button"
          >
            <ChevronRight className="se-w-4 se-h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
